import { useParams } from 'react-router'
import CurrentBillingCycle from './components/current-billing-cycle/CurrentBillingCycle.tsx'
import PreviousBillingCycle from './components/previous-billing-cycle/PreviousBillingCycle.tsx'

const BillingCycleDetail = () => {
  // URL Param
  const { id } = useParams<{ id: string }>()

  return id === 'current' ? <CurrentBillingCycle /> : <PreviousBillingCycle />
}

export default BillingCycleDetail
